export default __webpack_public_path__ + "static/media/tongueofxotli.ca76ff0d.png";